import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const TABS = {
    "api-6a": {
        label: "API 6A",
        title: "Wellhead & Drilling-Through Equipment",
        desc: "Specification for valves intended for wellhead and Christmas tree service — engineered for abrasive, high-pressure hydrocarbon duty.",
        rows: [
            ["Product Specification Levels", "PSL 1 – PSL 4"],
            ["Material Classes", "AA – FF"],
            ["Temperature Classes", "K – U"],
            ["Performance Verification", "PR2 tested"],
            ["Max Working Pressure", "15,000 PSI"],
        ],
    },
    "api-6d": {
        label: "API 6D",
        title: "Pipeline & Piping Valves",
        desc: "Specification for pipeline and piping valves for transmission and distribution systems — built for tight shut-off and long field life.",
        rows: [
            ["Bore Configuration", "Full & reduced"],
            ["Double Block & Bleed", "Verified"],
            ["Fire-Safe Qualification", "API 6FA / ISO 10497"],
            ["Fugitive Emissions", "ISO 15848-1"],
            ["Seat Testing", "Hydrostatic & pneumatic"],
        ],
    },
};

export default function Quality() {
    const [active, setActive] = useState("api-6a");

    return (
        <section
            id="quality"
            data-testid="quality-section"
            className="tech-grid"
        >
            <div className="mx-auto grid max-w-7xl gap-14 px-6 py-24 sm:px-8 lg:grid-cols-[1fr_1.4fr] lg:gap-20 lg:py-32">
                <div>
                    <p className="mb-5 flex items-center gap-3 font-mono text-[11px] font-semibold uppercase tracking-[0.3em] text-tactical">
                        <span className="h-px w-10 bg-tactical" />
                        Quality &amp; Compliance
                    </p>
                    <h2 className="font-display text-5xl font-bold uppercase leading-[0.95] tracking-tight text-slate-100 sm:text-6xl">
                        Engineered to the standard.
                    </h2>
                    <p className="mt-6 max-w-md leading-relaxed text-slate-400">
                        Compliance isn&apos;t paperwork — it&apos;s the
                        baseline every Blackhawk valve is designed, machined
                        and tested against before dispatch.
                    </p>
                </div>

                <div>
                    <div className="flex border border-steel">
                        {Object.entries(TABS).map(([key, tab]) => (
                            <button
                                key={key}
                                data-testid={`tab-${key}`}
                                onClick={() => setActive(key)}
                                className={`flex-1 py-4 font-mono text-xs font-bold uppercase tracking-[0.25em] transition-colors duration-300 ${
                                    active === key
                                        ? "bg-tactical text-obsidian"
                                        : "text-slate-400 hover:text-slate-100"
                                }`}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    <AnimatePresence mode="wait">
                        <motion.div
                            key={active}
                            data-testid={`quality-panel-${active}`}
                            initial={{ opacity: 0, y: 16 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -12 }}
                            transition={{ duration: 0.35 }}
                            className="border border-t-0 border-steel bg-obsidian-800 p-8 sm:p-10"
                        >
                            <h3 className="font-display text-2xl font-bold uppercase tracking-wide text-tactical sm:text-3xl">
                                {TABS[active].title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-slate-400">
                                {TABS[active].desc}
                            </p>
                            <dl className="mt-8 border-t border-white/10">
                                {TABS[active].rows.map(([k, v]) => (
                                    <div
                                        key={k}
                                        className="flex items-center justify-between gap-6 border-b border-white/10 py-4"
                                    >
                                        <dt className="font-mono text-[11px] uppercase tracking-[0.18em] text-slate-400">
                                            {k}
                                        </dt>
                                        <dd className="text-right font-display text-lg font-bold uppercase tracking-wide text-slate-100">
                                            {v}
                                        </dd>
                                    </div>
                                ))}
                            </dl>
                        </motion.div>
                    </AnimatePresence>
                </div>
            </div>
        </section>
    );
}
